import { useMemo } from 'react';

import { useQueryHubsResourceReport } from '../../../api';

import type { HubReportStatus } from '#entities';

export const useHubReportGroups = () => {
  const { data: hubs } = useQueryHubsResourceReport();
  return useMemo(
    () =>
      hubs.reduce<Record<string, HubReportStatus[]>>((acc, hub) => {
        const groupKey = hub.location.region;
        if (!acc[groupKey]) {
          acc[groupKey] = [];
        }
        acc[groupKey].push(hub);
        return acc;
      }, {}),
    [hubs],
  );
};
